import { Injectable } from '@angular/core';
import { ValidacionClienteService } from './validacion-cliente.service';
import { EncryptRSAService } from './encrypt-rsa.service';
import { AuthGuard } from '../guard/auth.guard';
import { Router } from '@angular/router';
import { CatalogoMensaje } from '../constants/catalogo';
import { Subscription } from 'rxjs';
import { AnalyticsService } from './analytics.service';

@Injectable({
  providedIn: 'root'
})
export class CallEquifaxService {
  servicioIntermitente = CatalogoMensaje.servicioIntermitente;
  private errorServicioEquifax: string;
  private encryptedCedula: string;
  private rutSinPunto: string;
  private readonly subs = new Subscription();
  constructor(
    private readonly router: Router,
    private readonly validacionClienteService: ValidacionClienteService,
    private readonly analyticsService: AnalyticsService,
    private readonly encryptService: EncryptRSAService,
    private readonly authGuard: AuthGuard
  ) {}
  setSecurityQuestions(rut: string, cedula: string): Promise<string | null> {
    this.encryptedCedula = cedula;
    this.rutSinPunto = rut;

    return this.encryptService
      .toEncrypt(this.encryptedCedula)
      .then((encryptedData) => {
        const request = {
          rut: this.rutSinPunto.split('-').join(''),
          serie: encryptedData
        };

        return new Promise<string | null>((resolve) => {
          const sub = this.validacionClienteService
            .obtenerPreguntas(request)
            .subscribe(
              (data) => {
                this.authGuard.setActivated = true;
                this.validacionClienteService.setPreguntas(data);
                this.router.navigate(['estado-situacion/preguntas']);
                resolve(null); // no hay error
              },
              (error) => {
                const errorPreguntas = error.error;
                const tieneError = [
                  '3',
                  '4',
                  'D9',
                  'SI',
                  'G7',
                  'S4',
                  'S9',
                  'SA',
                  'SM',
                  'OA8005',
                  '0A1008',
                  '0A1010',
                  '0A1011',
                  '0A1012'
                ].some((x) => x === errorPreguntas.error);

                if (tieneError) {
                  this.setEventAnalytics(errorPreguntas.mensaje);
                  resolve(this.errorServicioEquifax);
                } else if (errorPreguntas.error === 'OA1017') {
                  this.authGuard.setActivated = true;
                  this.router.navigate(['estado-situacion/error'], {
                    queryParams: { type: 'max-intentos' }
                  });
                  resolve(null);
                } else {
                  this.setEventAnalytics(this.servicioIntermitente);
                  resolve(this.errorServicioEquifax);
                }
              }
            );
          this.subs.add(sub);
        });
      });
  }

  setEventAnalytics(msg: string) {
    this.errorServicioEquifax = msg;
    this.analyticsService.mensaje({
      label: msg,
      action: 'view',
      channel: 'browser',
      element_id: undefined,
      type: 'alert warning',
      section: 'inicio'
    });
  }
}
